import axios, { AxiosError, AxiosRequestConfig } from 'axios';

export const sendAxiosRequest = (config: AxiosRequestConfig) =>
  axios(config)
    .then(resp => {
      // console.log(resp);
      // if (resp.data.response.data) {
      //   console.log(resp.data);
      // }
      return resp;
    })
    .catch((err: AxiosError) => {
      const errResp = err.response?.data;
      if (errResp) console.log(errResp);
      return { data: errResp || {} };
    });
